import React from "react";
import { TableBody, TableRow, TableCell, Checkbox, Box } from "@mui/material";
import { grey } from "@mui/material/colors";
import { flexRender } from "@tanstack/react-table";

const defCellpadding = 1;

const TanstackDatagridBody = ({
	table,
	rowHeight,
	checkboxSelection,
	editingCell,
	setEditingCell,
	validationErrors,
	isCellEditable,
	handleCellBlur,
	handleKeyDown,
	handleRowClick,
	getRowId,
	inputRef,
	buildRenderContext,
}) => {
	return (
		<TableBody>
			{table.getRowModel().rows.map((row, rIndex) => {
				const id = getRowId(row.original);
				return (
					<TableRow
						key={id}
						selected={row.getIsSelected()}
						hover
						sx={{ height: rowHeight, maxHeight: rowHeight }}
						onClick={(e) => handleRowClick({ row: row.original }, e)}>
						{checkboxSelection && (
							<TableCell padding="checkbox">
								<Checkbox
									checked={row.getIsSelected()}
									onClick={(e) => e.stopPropagation()}
									onChange={row.getToggleSelectedHandler()}
								/>
							</TableCell>
						)}
						{row.getVisibleCells().map((cell, cIndex) => {
							const meta = cell.column.columnDef.meta || {};
							const isEditing = editingCell?.rowId === id && editingCell?.columnId === cell.column.id;
							const error = validationErrors[`${id}_${cell.column.id}`];

							return (
								<TableCell
									key={cell.id}
									style={{ width: `${cell.column.getSize()}px` }}
									onDoubleClick={() => {
										if (isCellEditable({ row: row.original, column: meta })) {
											setEditingCell({ rowId: id, columnId: cell.column.id });
										}
									}}
									sx={{
										boxSizing: "border-box",
										cursor: meta.editable ? "text" : "default",
										p: 0,
										height: rowHeight,
										maxHeight: rowHeight,
										overflow: "hidden",
										verticalAlign: "middle",
									}}>
									{isEditing && meta.renderEditCell ? (
										<Box
											sx={{
												width: "100%",
												height: "100%",
												display: "flex",
												alignItems: "stretch",
												boxSizing: "border-box",
												border: error ? `2px solid red` : `2px solid ${grey[400]}`,
												borderRadius: 1,
											}}>
											<meta.renderEditCell
												ref={inputRef}
												{...buildRenderContext({ value: cell.getValue(), row: row.original, rowModel: row, column: meta, cell, table })}
												value={cell.getValue()}
												type={meta.dataType === "DECIMAL" ? "number" : "text"}
												onBlur={(e) => handleCellBlur(row.original, cell.column.id, e.target.value, meta.constraints)}
												onKeyDown={(e) => handleKeyDown(e, rIndex, cIndex, row.original, cell.column.id, meta.constraints)}
											/>
										</Box>
									) : (
										<Box
											sx={{
												width: "100%",
												height: "100%",
												display: "flex",
												alignItems: "center",
												boxSizing: "border-box",
												overflow: "hidden",
												minWidth: 0,
											}}>
											{flexRender(cell.column.columnDef.cell, cell.getContext())}
										</Box>
									)}
								</TableCell>
							);
						})}
					</TableRow>
				);
			})}
		</TableBody>
	);
};

export default TanstackDatagridBody;
